<template>
  <div class="user-list-box">
    <OperationBoxComponent :actions="actions" :filters="filters" :disabled="params.ids.length === 0" />
    <MilkUserListComponent
      :page-data="pageData"
      @onSelectChanged="onSelectChanged"
      @onPageChanged="onPageChanged"
      @view="view"
      @pass="pass"
      @refuse="refuse"
    />
    <el-dialog title="会员详情" :visible.sync="showDetailDialog" width="30%" @closed="showDetailDialog=false" :close-on-click-modal="false">
      <div class="detail-item">
        <span class="title">申请类型：</span>
        <span class="value">商家</span>
      </div>
      <div class="detail-item">
        <span class="title">姓&emsp;&emsp;名：</span>
        <span class="value">{{detail.name}}</span>
      </div>
      <div class="detail-item">
        <span class="title">手机号码：</span>
        <span class="value">{{detail.phone}}</span>
      </div>
      <div class="detail-item">
        <span class="title">所在学校：</span>
        <span class="value">{{detail.address}}</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button v-if="detail.status === 0" type="primary" @click="pass(detail)">通过</el-button>
        <el-button v-if="detail.status === 0" type="danger" @click="refuse(detail)">不通过</el-button>
        <el-button v-if="detail.status !== 0" type="danger" @click="remove(detail)">删除</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import OperationBoxComponent from '../../../components/common/OperationBoxComponent'
import GoodsListComponent from '../../../components/goods/GoodsListComponent'
import MilkUserListComponent from '../../../components/user/MilkUserListComponent'
import {MilkRequestUtil} from '../../../utils/MilkRequestUtil'
import {MessageUtil} from '../../../utils/MessageUtil'

export default {
  name: 'MilkUserListPage',
  components: {
    MilkUserListComponent,
    GoodsListComponent,
    OperationBoxComponent
  },
  mounted () {
    this.updateMemberList()
  },
  data () {
    return {
      actions: [
        { title: '', disabled: false, icon: 'el-icon-refresh', type: 'button', theme: 'primary', action: this.updateMemberList },
        {
          title: '审核状态',
          type: 'select',
          action: this.onUserStateChange,
          options: [
            { title: '待审核', value: 0 },
            { title: '审核通过', value: 1 },
            { title: '审核失败', value: 2 }
          ]
        }
      ],
      filters: [{
        searchValue: '',
        type: 'name',
        title: '名称',
        action: this.onFilterChange
      }],
      pageData: {},
      params: {
        ids: []
      },
      showDetailDialog: false,
      detail: {},
      queryParam: {
        page: 1,
        pageSize: 25,
        status: null,
        appid: null,
        type: null,
        keywords: null
      }
    }
  },
  methods: {
    updateMemberList () {
      let that = this
      MilkRequestUtil.queryMemberList({ queryParam: this.queryParam }, function (response) {
        if (response.items) {
          that.pageData = response
        }
      })
    },
    onUserStateChange (item) {
      this.queryParam.status = parseInt(item.selectValue)
      this.updateMemberList()
    },
    onAppChange (item) {
      this.queryParam.appid = item.selectValue
      this.updateMemberList()
    },
    onFilterChange (item) {
      this.queryParam.type = item.type
      this.queryParam.keywords = item.searchValue
      this.updateMemberList()
    },
    onSelectChanged (ids) {
      this.params.ids = ids
    },
    onPageChanged (page) {
      this.queryParam.page = page
      this.updateMemberList()
    },
    view (item) {
      this.showDetailDialog = true
      this.detail = item
    },
    pass (item) {
      let that = this
      MessageUtil.tipsConfirm('通过此申请？', 'warning', () => {
        that.showDetailDialog = false
        MilkRequestUtil.passMember({ id: item.id }, function () {
          that.$message.success('操作成功')
          setTimeout(function () {
            that.updateMemberList()
          }, 1000)
        })
      })
    },
    refuse (item) {
      let that = this
      MessageUtil.tipsConfirm('不通过此申请？', 'warning', () => {
        that.showDetailDialog = false
        MilkRequestUtil.refuseMember({ id: item.id }, function () {
          that.$message.success('操作成功')
          setTimeout(function () {
            that.updateMemberList()
          }, 1000)
        })
      })
    },
    remove (item) {
      let that = this
      MessageUtil.tipsConfirm('删除此申请？', 'warning', () => {
        that.showDetailDialog = false
        MilkRequestUtil.removeMember({ id: item.id }, function () {
          that.$message.success('操作成功')
          setTimeout(function () {
            that.updateMemberList()
          }, 1000)
        })
      })
    }
  }
}
</script>

<style scoped lang="less">
.detail-item{
  font-size: 16px;
  padding:10px 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/milk/user/MilkUserListPage.vue